module.exports = __webpack_public_path__ + "static/img/cu.2e0e65e6.svg";